import React, { Component } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import axios from 'axios';
import Loader from "../../../components/Loader";

import SchoolsAdmissions from "../Charts/DEM/SchoolsAdmissions";
import InspectedSchools from "../Charts/DEM/InspectedSchools";
import InspectedSecondarySchools from "../Charts/DEM/InspectedSecondarySchools";
import InspectedPrimarySchools from "../Charts/DEM/InspectedPrimarySchools";
import TotalSchools from "../Charts/DEM/TotalSchools";
import DistrictProgressGraph from "../Reports/DistrictProgressGraph";
import TabledDataSummaries from "./TabledDataSummaries";

import "chartist/dist/scss/chartist.scss";
import { School, Apartment, Grade } from '@material-ui/icons';

import backend_url from "../../../routes/API_URL";
import swal from 'sweetalert';

const API_URL = backend_url['api_url'];

class DistrictDashboard extends Component {
  constructor(props) {
    super(props);
    
    // Get district_id from session storage
    const districtIdFromStorage = window.sessionStorage.getItem("district");
    const userRole = window.sessionStorage.getItem("urole");
    
   
    this.state = {
      Sec_Data: [],
      Prim_Data: [],
      Schools: [],
      Zones: [],
      Clusters: [],
      Constituencies: [],
      Districts: [],
      Divisions: [],
      Standards: [],
      Requirements: [],
      Levels: [],
      NesCategories: [],
      district_id: districtIdFromStorage,
      bearer_auth: window.sessionStorage.getItem('token'),
      district_name: '',
      loading: false,
      error: null,
      dataLoaded: false
    };
  }
  
  componentDidMount() {
    this.validateAndFetchData();
  }
  
  validateAndFetchData() {
    const { district_id, bearer_auth } = this.state;
    
    // Check if user is authenticated
    if (!bearer_auth) {
      this.setState({ 
        error: 'No authentication token found. Please log in.',
        loading: false
      });
      return;
    }
    
    // Validate district_id
    if (!district_id || district_id === 'undefined' || district_id === 'null' || district_id === '') {
      console.error('DistrictDashboard - Invalid district ID:', district_id);
      this.setState({ 
        error: 'No valid district ID found. Please ensure you have a district assigned to your account.',
        loading: false
      });
      return;
    }
    
    this.fetchDashboardData();
  }
  
  fetchDashboardData() {
    const { district_id, bearer_auth } = this.state;
    
    this.setState({ loading: true, error: null });
    
 
    // Create an array of promises with error handling for each
    const promises = [
      axios.get(`${API_URL}/total_schools/primary/by_district/${district_id}`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
      axios.get(`${API_URL}/total_schools/secondary/by_district/${district_id}`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
      axios.get(`${API_URL}/total_zones/by_district/${district_id}`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
      axios.get(`${API_URL}/total_clusters/by_district/${district_id}`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
      axios.get(`${API_URL}/total_constituencies`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
      axios.get(`${API_URL}/total_districts`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
      axios.get(`${API_URL}/total_divisions`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
      axios.get(`${API_URL}/total_nes`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
      axios.get(`${API_URL}/total_nes_requirements`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
      axios.get(`${API_URL}/total_nes_levels`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
      axios.get(`${API_URL}/total_nes_categories`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
      axios.get(`${API_URL}/districts/${district_id}`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [] } }))
    ];
    
    Promise.all(promises)
      .then(([p_data, s_data, zone, cluster, constituency, district, division, standard, req, level, category, district_data]) => {
        
        // Helper function to safely extract data
        const extractCount = (data, defaultValue = 0) => {
          if (data && data.data && data.data.length >= 1 && data.data[0] && data.data[0].COUNT !== undefined) {
            return data.data[0];
          }
          if (data && data.data && data.data.length >= 1) {
            return data.data[0];
          }
          if (data && data.data) {
            return data.data;
          }
          return { COUNT: defaultValue };
        };
        
        // Extract district name
        let districtName = 'UNKNOWN DISTRICT';
        if (district_data && district_data.data && district_data.data.length >= 1) {
          districtName = district_data.data[0]['district_name'] + " EDUCATIONAL DISTRICT";
        } else if (district_data && district_data.data && district_data.data.district_name) {
          districtName = district_data.data.district_name + " EDUCATIONAL DISTRICT";
        }
        
        this.setState({
          Prim_Data: extractCount(p_data),
          Sec_Data: extractCount(s_data),
          Zones: extractCount(zone),
          Clusters: extractCount(cluster),
          Constituencies: extractCount(constituency),
          Districts: extractCount(district),
          Divisions: extractCount(division),
          Standards: extractCount(standard),
          Requirements: extractCount(req),
          Levels: extractCount(level),
          NesCategories: extractCount(category),
          district_name: districtName,
          loading: false,
          dataLoaded: true,
          error: null
        });
        
       
      })
      .catch(error => {
        console.error('DistrictDashboard - Error loading data:', error);
        this.setState({ 
          loading: false,
          error: 'Failed to load dashboard data'
        });
        
        if (error.response?.status === 401) {
          swal({
            title: "",
            text: "Your session has expired. You'll automatically be logged out within seconds.",
            icon: "error",
            timer: 2000
          }).then(() => {
            window.sessionStorage.clear();
            window.location.href = '/login';
          });
        } else {
          swal({
            title: "",
            text: "Failed to load the dashboard data. We will refresh the page in seconds..",
            icon: "error",
            timer: 5000
          }).then(() => {
            window.location.reload();
          });
        }
      });
  }

  render() {
    const { 
      Prim_Data, Sec_Data, Zones, Clusters, Constituencies, 
      Districts, Divisions, district_id, district_name, loading, error, dataLoaded
    } = this.state;
    
    return (
      <React.Fragment>
        <div className="container-fluid">
          {/* Loader */}
          <Row className="position-center">
            {loading && <Loader />}
          </Row>
          
          {/* Error Display */}
          {error && !loading && (
            <Row>
              <Col xs={12}>
                <Card className="bg-danger text-white">
                  <CardBody>
                    <center>
                      <h5>{error}</h5>
                      <p>District ID: {district_id || 'Not available'}</p>
                      <Link to="/login" className="btn btn-light mt-2">Go to Login</Link>
                    </center>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
          
          {/* Header */}
          <Row className="align-items-center">
            <Col sm={6}>
              <div className="page-title-box">
                <h5 className="font-size-18">
                  {district_name && district_name !== 'NULL DATA ON' 
                    ? district_name.toUpperCase() 
                    : 'DISTRICT DASHBOARD'}
                </h5>
                <hr />
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/#">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">District Dashboard</li>
                </ol>
              </div>
            </Col>
            <Col sm="6">
              <div className="float-right d-none d-md-block"></div>
            </Col>
          </Row>
          
          {/* Quick Links (Hidden) */}
          <Row hidden>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <h6 className="card-title mb-4">QUICK LINKS</h6>
                  <hr className="bg-success" />
                  <Row className="text-white">
                    <Col xs={12} sm={6} md={2}>
                      <Link className="text-white" to="/divisions">
                        <Card className="bg-success">
                          <CardBody><center>Divisions</center></CardBody>
                        </Card>
                      </Link>
                    </Col>
                    <Col xs={12} sm={6} md={2}>
                      <Link className="text-white" to="/districts">
                        <Card className="bg-success">
                          <CardBody><center>Districts</center></CardBody>
                        </Card>
                      </Link>
                    </Col>
                    <Col xs={12} sm={6} md={2}>
                      <Link className="text-white" to="/constituencies">
                        <Card className="bg-success">
                          <CardBody><center>Constituencies</center></CardBody>
                        </Card>
                      </Link>
                    </Col>
                    <Col xs={12} sm={6} md={2}>
                      <Link className="text-white" to="/zones">
                        <Card className="bg-success">
                          <CardBody><center>Zones/Clusters</center></CardBody>
                        </Card>
                      </Link>
                    </Col>
                    <Col xs={12} sm={6} md={2}>
                      <Link className="text-white" to="/schools">
                        <Card className="bg-success">
                          <CardBody><center>Schools</center></CardBody>
                        </Card>
                      </Link>
                    </Col>
                    <Col xs={12} sm={6} md={2}>
                      <Link className="text-white" to="/nes_categories">
                        <Card className="bg-success">
                          <CardBody><center>NES Categories</center></CardBody>
                        </Card>
                      </Link>
                    </Col>
                  </Row>
                  <hr className="bg-success" />
                  <Row className="text-white">
                    <Col xs={12} sm={6} md={2}>
                      <Link className="text-white" to="/national_standards">
                        <Card className="bg-success">
                          <CardBody><center>Education Standards</center></CardBody>
                        </Card>
                      </Link>
                    </Col>
                    <Col xs={12} sm={6} md={2}>
                      <Link className="text-white" to="/nes_requirements">
                        <Card className="bg-success">
                          <CardBody><center>NES Requirements</center></CardBody>
                        </Card>
                      </Link>
                    </Col>
                    <Col xs={12} sm={6} md={2}>
                      <Link className="text-white" to="/school_visits">
                        <Card className="bg-success">
                          <CardBody><center>Inspection Visits</center></CardBody>
                        </Card>
                      </Link>
                    </Col>
                    <Col xs={12} sm={6} md={2}>
                      <Link className="text-white" to="/advisory_visits">
                        <Card className="bg-success">
                          <CardBody><center>Advisory Visits</center></CardBody>
                        </Card>
                      </Link>
                    </Col>
                    <Col xs={12} sm={6} md={2}>
                      <Link className="text-white" to="/perf_report">
                        <Card className="bg-success">
                          <CardBody><center>Performance Graph(s)</center></CardBody>
                        </Card>
                      </Link>
                    </Col>
                    <Col xs={12} sm={6} md={2}>
                      <Link className="text-white" to="/progress_report">
                        <Card className="bg-success">
                          <CardBody><center>Progress Report</center></CardBody>
                        </Card>
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          
          {/* Statistics Section */}
          {district_id && district_id !== 'undefined' && district_id !== 'null' && !error && (
            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <h6 className="card-title mb-4">QUICK STATISTICS</h6>
                    <hr className="bg-success" />
                    <Row className="text-white">
                      <Col xs={12} sm={6} md={3}>
                        <Link className="text-success" to="/schools">
                          <Card className="border border-success">
                            <CardBody>
                              <span className="float-left">Primary Schools</span>
                              <span className="float-right"><School fontSize="large" /></span>
                              <br />
                              <hr />
                              <center>
                                <strong><h2>{Prim_Data && Prim_Data['COUNT'] !== undefined ? Prim_Data['COUNT'] : 0}</h2></strong>
                              </center>
                            </CardBody>
                          </Card>
                        </Link>
                      </Col>
                      
                      <Col xs={12} sm={6} md={3}>
                        <Link className="text-success" to="/schools">
                          <Card className="border border-success">
                            <CardBody>
                              <span className="float-left">Secondary Schools</span>
                              <span className="float-right"><School fontSize="large" /></span>
                              <br />
                              <hr />
                              <center>
                                <strong><h2>{Sec_Data && Sec_Data['COUNT'] !== undefined ? Sec_Data['COUNT'] : 0}</h2></strong>
                              </center>
                            </CardBody>
                          </Card>
                        </Link>
                      </Col>
                      
                      <Col xs={12} sm={6} md={3}>
                        <Link className="text-success" to="/zones">
                          <Card className="border border-success">
                            <CardBody>
                              <span className="float-left">Zones</span>
                              <span className="float-right"><Apartment fontSize="large" /></span>
                              <br />
                              <hr />
                              <center>
                                <strong><h2>{Zones && Zones['COUNT'] !== undefined ? Zones['COUNT'] : 0}</h2></strong>
                              </center>
                            </CardBody>
                          </Card>
                        </Link>
                      </Col>
                      
                      <Col xs={12} sm={6} md={3}>
                        <Link className="text-success" to="/clusters">
                          <Card className="border border-success">
                            <CardBody>
                              <span className="float-left">Clusters</span>
                              <span className="float-right"><Apartment fontSize="large" /></span>
                              <br />
                              <hr />
                              <center>
                                <strong><h2>{Clusters && Clusters['COUNT'] !== undefined ? Clusters['COUNT'] : 0}</h2></strong>
                              </center>
                            </CardBody>
                          </Card>
                        </Link>
                      </Col>
                    </Row>
                    
                    <hr className="bg-success" />
                    
                    <Row hidden className="text-white">
                      <Col xs={12} sm={6} md={4}>
                        <Link className="text-success" to="/constituencies">
                          <Card className="border border-success">
                            <CardBody>
                              <span className="float-left">Constituencies</span>
                              <span className="float-right"><Apartment fontSize="large" /></span>
                              <br />
                              <hr />
                              <center>
                                <strong><h2>{Constituencies && Constituencies['COUNT'] !== undefined ? Constituencies['COUNT'] : 0}</h2></strong>
                              </center>
                            </CardBody>
                          </Card>
                        </Link>
                      </Col>
                      
                      <Col xs={12} sm={6} md={4}>
                        <Link className="text-success" to="/districts">
                          <Card className="border border-success">
                            <CardBody>
                              <span className="float-left">Districts</span>
                              <span className="float-right"><Grade fontSize="large" /></span>
                              <br />
                              <hr />
                              <center>
                                <strong><h2>{Districts && Districts['COUNT'] !== undefined ? Districts['COUNT'] : 0}</h2></strong>
                              </center>
                            </CardBody>
                          </Card>
                        </Link>
                      </Col>
                      
                      <Col xs={12} sm={6} md={4}>
                        <Link className="text-success" to="/divisions">
                          <Card className="border border-success">
                            <CardBody>
                              <span className="float-left">Divisions</span>
                              <span className="float-right"><Grade fontSize="large" /></span>
                              <br />
                              <hr />
                              <center>
                                <strong><h2>{Divisions && Divisions['COUNT'] !== undefined ? Divisions['COUNT'] : 0}</h2></strong>
                              </center>
                            </CardBody>
                          </Card>
                        </Link>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
          
          {/* Inspected Schools */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <InspectedSchools />
                </CardBody>
              </Card>
            </Col>
          </Row>
          
          {/* District Progress Graph - WITH district_id PROPERLY PASSED */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  {district_id && district_id !== 'undefined' && district_id !== 'null' ? (
                    <DistrictProgressGraph 
                      district_id={district_id}
                      header="years"
                    />
                  ) : (
                    <div className="text-center p-5">
                      <h5 className="text-warning">No District Selected</h5>
                      <p>District ID: {district_id || 'Not available'}</p>
                      <p>Please ensure your account has a district assigned.</p>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

export default DistrictDashboard;